import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { BillingReadOnlyModal } from './BillingReadOnlyModal';
import { useRefreshTeamBillingState, useTeamBillingState, TEAM_BILLING_PATH } from '../hooks/useTeamBillingState';
import { TEAM_BILLING_READ_ONLY_EVENT, isBillingReadOnlyModalClaimed } from '../utils/teamBillingReadOnly';

/**
 * BillingDunning: app-level listener for 403 TEAM_BILLING_READ_ONLY. Refreshes the team's billing
 * state from /auth/me (so the banner and disabled buttons catch up) and explains the refusal.
 * The case editor shows its own modal, so this one stays closed while a case is open.
 */
export const BillingReadOnlyGate: React.FC = () => {
    const navigate = useNavigate();
    const refreshTeam = useRefreshTeamBillingState();
    const { canManageBilling } = useTeamBillingState();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const handler = () => {
            void refreshTeam();
            if (!isBillingReadOnlyModalClaimed()) setOpen(true);
        };
        window.addEventListener(TEAM_BILLING_READ_ONLY_EVENT, handler);
        return () => window.removeEventListener(TEAM_BILLING_READ_ONLY_EVENT, handler);
    }, [refreshTeam]);

    return (
        <BillingReadOnlyModal
            isOpen={open}
            canManageBilling={canManageBilling}
            closeLabel="Close"
            onClose={() => setOpen(false)}
            onPayNow={() => {
                setOpen(false);
                navigate(TEAM_BILLING_PATH);
            }}
        />
    );
};
